import * as React from 'react'
// constants
import { Modals } from 'constants/index'
//context
import { ReviewsListBLContext } from 'containers/Review/ReviewList/layers/BL'
// views
import { Wrapper } from 'components/Modals/PlanItems/components/ReviewsList/views'
// view components
import ScheduleReviewLink from 'components/Modals/CreateScheduledReviewModal/components/ScheduleReviewLink'
import ReviewCard from 'containers/Review/ReviewCard'
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
// utils
import moment from 'moment'

const ReviewsList: React.FC = () => {
  const { canCreate, reviews } = React.useContext(ReviewsListBLContext)

  return (
    <Wrapper>
      {canCreate && <ScheduleReviewLink />}

      {reviews.map((review) => (
        <ReviewCard key={moment(review.startPeriod).toISOString()} review={review} />
      ))}

      <ConfirmDeleteModal header={'Delete Review Schedule'} modalType={Modals.CONFIRM_DELETE_SCHEDULED_REVIEW}>
        Are you sure you want to delete this review schedule?
      </ConfirmDeleteModal>
      <ConfirmDeleteModal header={'Delete Review'} modalType={Modals.CONFIRM_DELETE_REVIEW_MODAL}>
        Are you sure you want to delete this review?
      </ConfirmDeleteModal>
    </Wrapper>
  )
}

export default ReviewsList
